// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__11_L-","amount":"style_amount__1G0PZ"};